<template>
  <HeaderTrade/> 
  <!-- Container Start { -->
  <div id="container">
    <!-- Contents Start { -->
    <div id="contents">
      
      <div class="policy-box">
        <Policy/>
      </div>

    </div>
    <!-- } Contents End -->

  </div>
  <!-- } Container End -->
  <Footer/>
</template>

<script>

import { useStore } from 'vuex';
import HeaderTrade from '@/components/HeaderTrade.vue';
import Footer from '@/components/Footer.vue';
import Policy from '@/components/terms/Policy.vue';

export default {
  components:{  
  HeaderTrade, 
  Footer,
  Policy,
},
  setup(){
    const store = useStore();
    store.commit('trade/CHANGE_CURRENT_PAGE_ID', 'navi_policy'); 
    store.commit('common/CHANGE_CURRENT_PAGE', 'Policy');    
    return {      

    }
  }
}
</script>

<style>

</style>